import delay from 'delay';

import copyToClipboard from '@/helpers/copy_to_clipboard';

pageLoad('info_pages_show', () => {
  const shareLink = document.querySelector('.share-like .link');
  if (shareLink) {
    $(shareLink).on('click', async () => {
      copyToClipboard(shareLink.getAttribute('data-href'));

      const tooltip = shareLink.nextSibling;
      tooltip.classList.add('is-copied');
      await delay(2000);
      tooltip.classList.remove('is-copied');
    });
  }

  $('button.like').on(
    'ajax:success',
    async ({ currentTarget }, { likes_count: likesCount, is_liked: isLiked }) => {
      currentTarget
        .querySelector('.count')
        .innerText = likesCount;

      currentTarget
        .classList
        .toggle('is-active', isLiked);
    });
});
